import $ from 'jquery';

const showCookieDialog = () => {
    const container = document.querySelector('.js-cookie-container');
    const bar = container.querySelector('.js-cookie-bar');
    const dialog = container.querySelector('.js-cookie-dialog');

    const addClass = element => {
        element.classList.add('u-hidden');
    }
    
    const removeClass = element => {
        element.classList.remove('u-hidden');
    }

    if (!bar.classList.contains('u-hidden')) {
        addClass(bar)
    }

    if (dialog.classList.contains('u-hidden')) {
        removeClass(dialog)
    }

    if (container.classList.contains('u-hidden')) {
        removeClass(container)
    }
};

const showCookieDialogInit = () => {
    const links = document.querySelectorAll('.js-show-cookie-dialog');

    if (!links.length) {
        return
    }

    links.forEach(link => {
        link.addEventListener('click', function(e){
            e.preventDefault();
            showCookieDialog()
        });
    })
}

$(() => {
    showCookieDialogInit();
});
